import { Box } from '@mui/material';
import { Login } from './login';
import { BreadcrumbsBar } from '../../breadcrumbs/breadcrumbsBar';
import { LoginRoute } from '../../../routes/allRoutes';

export function LoginPage() {
  return (
    <Box>
      <BreadcrumbsBar paths={[{ path: LoginRoute }]} />
      <Login />
    </Box>
  );
}
